import { SubmissionError } from '#helper/submission-error';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { FETCH_PROJECT_PRODUCTS } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

export const fetchProjectProducts = (id, includeArchived = false) => dispatch =>
  dispatch(fetchAdditions(`project/${id}/product${includeArchived ? '?includeArchived=true' : ''}`, FETCH_PROJECT_PRODUCTS, { id }));

export const putProjectProducts = (id, products) => async dispatch => {
  try {
    const res = await fetch(webPortalApi.buildApiUrl(`project/${id}/product`), {
      method: 'PUT',
      body: JSON.stringify(products),
      ...getRequestOptions()
    });
    const response = await res.json();

    if (!res.ok) {
      dispatch(
        snackBarError({
          message: 'Error in request',
          ...response
        })
      );
      throw new SubmissionError(response);
    }

    return { success: true };
  } catch (e) {
    return { success: false };
  }
};
